import { mapper, clamp } from '@/utils/Maths'

export default {
  props: {
    progress: {
      type: Number,
      default: 0
    },
    baseProgress: {
      type: Number,
      default: 0
    }
  },

  data () {
    return {
      opacity: 0
    }
  },

  created () {
    this.opacityOut = {
      min: 0,
      max: 1
    }
  },

  methods: {
    computeOpacity () {
      const delta = this.baseProgress - this.progress
      // if delta > 0, its before keypoint
      // starts to be visible at 0.07 before 
      // fully visible visible at 0.02 before
      this.opacity = delta > 0 ? mapper(delta, .07, .02, 0, 1) : mapper(delta, -.01, -.02, 1, 0)
      this.opacity = clamp(this.opacity, 0, 1)
    }
  }
}